<div class="cc-simsearch-section" id="cc-simsearch-section"></div>
<div class="cc-simsearch-view" *ngIf="!!vehicleConfiguration && !!similarVehicles && !!similarVehicles.length">
  <h3 class="wb-type-heading-m">{{ 'simSearch.availableVehicles' | translate }}</h3>
  <div
    class="wb-type-copy wb-margin-bottom-s wb-margin-top-xs"
    [innerHTML]="'simSearch.explanation' | translate | nl2br"
  ></div>

  <div class="cc-simsearch-view__table-container-overlay">
    <button
      type="button"
      class="wb-round-button wb-round-button--solid-level-2 wb-round-button--medium cc-simsearch-view__table-scroll-button left"
      aria-label="previous"
      (click)="scroll('left')"
      [hidden]="isScrolled('left')"
    >
      <wb-icon class="wb-round-button__icon hydrated" aria-hidden="true" name="chevron-left"> </wb-icon>
    </button>
    <button
      type="button"
      class="wb-round-button wb-round-button--solid-level-2 wb-round-button--medium cc-simsearch-view__table-scroll-button right"
      aria-label="next"
      (click)="scroll('right')"
      [hidden]="isScrolled('right')"
    >
      <wb-icon class="wb-round-button__icon hydrated" aria-hidden="true" name="chevron-right"> </wb-icon>
    </button>

    <div class="cc-simsearch-view__table-container" #scrollContainer (scroll)="onScroll()">
      <div class="cc-simsearch-view__table cc-simsearch-view__table-{{ simsearchColumns }}-columns">
        <ng-container
          *ngTemplateOutlet="
            vehicleTile;
            context: {
              isCurrentConfiguration: true,
              vehicle: vehicleConfiguration,
              zIndexModifier: similarVehicles.length + 1,
              trackingAction: 0
            }
          "
        ></ng-container>
        <ng-container *ngFor="let vehicle of similarVehicles; let i = index">
          <ng-container
            *ngTemplateOutlet="
              vehicleTile;
              context: {
                isCurrentConfiguration: false,
                vehicle: vehicle,
                zIndexModifier: similarVehicles.length - i,
                trackingAction: i + 1
              }
            "
          ></ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="cc-simsearch-view__footnotes">
    <cc-footnotes-list section="simsearch"></cc-footnotes-list>
  </div>
</div>

<ng-template
  #vehicleTile
  let-isCurrentConfiguration="isCurrentConfiguration"
  let-vehicle="vehicle"
  let-zIndexModifier="zIndexModifier"
  let-trackingAction="trackingAction"
>
  <div
    class="cc-simsearch-view__table-cell row-1 column-zindex-{{ zIndexModifier }} headline"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    <span *ngIf="isCurrentConfiguration">{{ 'simSearch.yourConfiguration' | translate }}</span>
    <span *ngIf="!isCurrentConfiguration">
      {{ 'simSearch.similarConfiguration' | translate | sprintf: vehicle.matchFactor }}
    </span>
    <span>{{ vehicle.name }}</span>
  </div>
  <div
    class="cc-simsearch-view__table-cell row-2 column-zindex-{{ zIndexModifier }} image"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    <div class="cc-simsearch-view__table-cell__flags" *ngIf="!!vehicle.labels">
      <ng-container *ngFor="let labelType of vehicle.labels">
        <cc-recommendation-label
          [labelType]="labelType"
          [displayType]="isCurrentConfiguration ? 'secondary-theme-dark' : 'secondary-theme-light'"
          [hasTooltip]="false"
        >
        </cc-recommendation-label>
      </ng-container>
    </div>

    <div
      *ngIf="!isCurrentConfiguration && vehicle.matchFactor"
      class="cc-simsearch-view__table-cell__matchfactor"
      attr.matchfactor="{{ vehicle.matchFactor }}"
      inViewport
      [inViewportOptions]="{ threshold: [0] }"
      (inViewportAction)="onInViewport($event, vehicle)"
    >
      <div class="cc-simsearch-view__table-cell__matchfactor--active-border">
        <div class="cc-simsearch-view__table-cell__matchfactor--circle">
          <span class="cc-simsearch-view__table-cell__matchfactor--percent wb-type-copy-strong">0 %</span>
        </div>
      </div>
    </div>

    <cc-image
      *ngIf="vehicle.imageSources"
      [srcset]="vehicle.imageSources?.srcSet"
      [sizes]="vehicle.imageSources?.sizes"
      [ratio]="500 / 281"
      [forceLoad]="false"
    >
    </cc-image>
  </div>

  <div
    *ccShowPrice
    class="cc-simsearch-view__table-cell row-3 column-zindex-{{ zIndexModifier }} price"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    {{ discountedOrConfigurationPrice(vehicle?.priceInformation) | formattedPrice }}

    <a
      *ngIf="vehicle?.priceInformation?.discountedPrice"
      ccOpenEnvironmentalBonusModal
      class="wb-link wb-link-inline cc-simsearch-view__env-bonus-hint"
    >
      ({{ 'environmentalBonus.includingManufacturerEnvironmentalBonus' | translate }})
    </a>

    <cc-footnote-hint
      *ngFor="let hint of vehicle.prices?.footnotes"
      [hint]="hint"
      [context]="'simsearch'"
      [section]="'simsearch'"
    >
    </cc-footnote-hint>
  </div>
  <div
    class="cc-simsearch-view__table-cell row-4 column-zindex-{{ zIndexModifier }} availability"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    <span>{{ 'simSearch.availability' | translate }}</span>
    <span *ngIf="isCurrentConfiguration">{{ 'simSearch.availableOnRequest' | translate }}</span>
    <ng-container *ngIf="!isCurrentConfiguration">
      <span>&bull;</span>
      <span>{{ 'simSearch.availableImmediately' | translate }}</span>
    </ng-container>
  </div>
  <ng-container *ngIf="vehicle | hasKey: 'location'">
    <div
      class="cc-simsearch-view__table-cell row-5 column-zindex-{{ zIndexModifier }} location"
      [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
    >
      <ng-container *ngIf="!isCurrentConfiguration">
        <span>{{ 'simSearch.location' | translate }}</span>
        <span>{{ vehicle.location }}</span>
      </ng-container>
      <ng-container *ngIf="isCurrentConfiguration">
        <span>&nbsp;</span>
        <span>&nbsp;</span>
      </ng-container>
    </div>
  </ng-container>
  <div
    class="cc-simsearch-view__table-cell row-{{ 5 + ((vehicle | hasKey: 'location') ? 1 : 0) }} column-zindex-{{
      zIndexModifier
    }} category"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    {{ 'simSearch.motorizationDetails' | translate }}
  </div>
  <ng-container *ngFor="let dataSet of vehicle.motorization; index as index; first as isFirst; last as isLast">
    <ng-container
      *ngTemplateOutlet="
        dataSetRow;
        context: {
          dataSet: dataSet,
          row: 6 + ((vehicle | hasKey: 'location') ? 1 : 0) + index,
          isCurrentConfiguration: isCurrentConfiguration,
          zIndexModifier: zIndexModifier,
          isFirst: isFirst,
          isLast: isLast
        }
      "
    ></ng-container>
  </ng-container>

  <div
    class="cc-simsearch-view__table-cell row-{{
      6 + ((vehicle | hasKey: 'location') ? 1 : 0) + vehicle.motorization.length
    }} column-zindex-{{ zIndexModifier }} category"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    {{ 'simSearch.vehicleDetails' | translate }}
  </div>
  <ng-container *ngFor="let dataSet of vehicle.categories; index as index; first as isFirst; last as isLast">
    <ng-container
      *ngTemplateOutlet="
        dataSetRow;
        context: {
          dataSet: {
            label: dataSet.name,
            value: dataSet.components | pluck: 'name' | join,
            changed: dataSet.changed ? dataSet.changed : (dataSet.components | pluck: 'changed' | join),
            footnotes: dataSet.footnotes
          },
          row: 7 + ((vehicle | hasKey: 'location') ? 1 : 0) + vehicle.motorization.length + index,
          isCurrentConfiguration: isCurrentConfiguration,
          zIndexModifier: zIndexModifier,
          isFirst: isFirst,
          isLast: isLast
        }
      "
    ></ng-container>
  </ng-container>

  <div
    class="cc-simsearch-view__table-cell row-{{
      7 + ((vehicle | hasKey: 'location') ? 1 : 0) + vehicle.motorization.length + vehicle.categories.length
    }} column-zindex-{{ zIndexModifier }} button"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration }"
  >
    <wb-button-control *ngIf="isCurrentConfiguration && (offerDealerContact$ | async)" variant="tertiary" size="medium">
      <a (click)="openContactMBPartnerModal()" [ccTrackClick]="getTrackingData(trackingAction)">
        {{ 'simSearch.contactMBPartner' | translate }}
      </a>
    </wb-button-control>
    <wb-button-control *ngIf="!isCurrentConfiguration && vehicle.link" variant="primary" size="medium" semi-transparent>
      <a
        [href]="vehicle.link + getTrackingParameter(vehicle)"
        target="_blank"
        rel="noopener"
        [ccTrackClick]="getTrackingData(trackingAction)"
      >
        {{ 'simSearch.viewDetailsInOnlineShop' | translate }}
      </a>
    </wb-button-control>
  </div>
</ng-template>

<ng-template
  #dataSetRow
  let-dataSet="dataSet"
  let-row="row"
  let-isCurrentConfiguration="isCurrentConfiguration"
  let-zIndexModifier="zIndexModifier"
  let-isFirst="isFirst"
  let-isLast="isLast"
>
  <div
    class="cc-simsearch-view__table-cell row-{{ row }} column-zindex-{{ zIndexModifier }} value"
    [ngClass]="{ 'fixed-cell': isCurrentConfiguration, 'first-in-category': isFirst, 'last-in-category': isLast }"
  >
    <span>
      <ng-container *ngIf="dataSet.label">{{ dataSet.label }}:</ng-container>
      <cc-footnote-hint
        *ngFor="let hint of dataSet.footnotes"
        [hint]="hint"
        [context]="'simsearch'"
        [section]="'simsearch'"
      >
      </cc-footnote-hint>
    </span>
    <span [ngClass]="{ highlight: dataSet.changed }">
      <ng-container *ngTemplateOutlet="dataSetValue"></ng-container>
    </span>
  </div>

  <ng-template #dataSetValue>
    <wb-icon *ngIf="dataSet.changed" name="warning"></wb-icon>
    {{ dataSet.value }}
  </ng-template>
</ng-template>
